module.exports = __webpack_public_path__ + "static/img/power.e0ce933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/power.png
// module id = FMBj
// module chunks = 1